import { request } from "./client";

export type AlertType = "site_created" | "text_edit";

/** One dashboard alert — a projection of a site_audit_log event. */
export interface Alert {
  id: string;
  type: AlertType;
  siteId: string;
  subdomain: string;
  /** ISO timestamp of the event. */
  at: string;
}

export const activityApi = {
  getActivity: () => request<{ activity: Alert[] }>("/api/activity"),
};
